import React from 'react';
import { Link } from 'react-router-dom';

const NoPage = () => {
  return (
    <div className="bg-gray-100 flex items-center justify-center h-screen p-4">
      <div className="text-center">
        <h1 className="text-5xl font-bold text-emerald-600 mb-2">404</h1>
        <h2 className="text-3xl mt-4 text-gray-600">Not Found</h2>
        <p className="mt-2 text-gray-500 mb-10">
          The page you are looking for does not exist.
        </p>
        <Link
          to="/"
          className="mt-2 bg-emerald-600 text-white hover:bg-opacity-90 focus:ring-4 focus:outline-none focus:ring-red-300 font-medium rounded-lg text-sm w-full px-5 py-2.5 text-center block"
        >
          Go to Homepage
        </Link>
      </div>
    </div>
  );
};

export default NoPage;
